
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { environment } from '../environments/environment';
import { IPrivateSpace } from '../models/privateSpace.model';
import { Product } from '../models/product.model';
import { Service } from '../models/service.model';


@Injectable({
  providedIn: 'root'
})

export class PrivateSpaceService{

  constructor(private http: HttpClient){}

  getPrivateSpaceOld(page: number, size: number) : Observable<any>{
    return this.http.get<any>(`${environment.url}/privateSpace?page=${page}&size=${size}`);
  }

  getPrivateSpace() : Observable<any>{
    return this.http.get<any>(`${environment.url}/privateSpace`);
  }
  query(page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/privateSpace/seller` + (size ? '?page=' + page + '&size=' + size : ''),{'headers': headers});
  }

  getSellerPrivateSpaceOld(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/privateSpace/seller_space`,{'headers': headers});
  }

  getSellerPrivateSpace(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/privateSpace/author_space`,{'headers': headers});
  }

  getOwerPrivateSpace(page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/privateSpace/author` + (size ? '?page=' + page + '&size=' + size : ''),{'headers': headers});
  }

  getPrivateSpaceBycurrentSearch(search: string, page: number, size: number){
    return this.http.get<any>(`${environment.url}/privateSpace` + ('/_search?search=name:' + search +'&page=' + page + "&size=" + size));
  }

  savePrivateSpace(PrivateSpace:IPrivateSpace){
    return this.http.post<any>(`${environment.url}/privateSpace`,PrivateSpace);
  }

  addCustomerToPrivateSpace(id: number, userId: String){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.put<any>(`${environment.url}/privateSpace/add/` +id+`?userId=${userId}`,{'headers': headers});
  }

  getByProduct(productId: number){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/privateSpace/product?productId=${productId}`,{'headers': headers});
  }

  getByService(serviceId: number){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/privateSpace/service?serviceId=${serviceId}`,{'headers': headers});
  }

  addManagerForPrivateSpace(id: number, userId: String){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.put<any>(`${environment.url}/privateSpace/add/manager/` +id+`?userId=${userId}`,{'headers': headers});
  }

  getIdPrivateSpace(idA:number){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get(`${environment.url}/privateSpace/`+idA,{'headers': headers});
  }

  updatePrivateSpace(PrivateSpace:IPrivateSpace){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.put<any>(`${environment.url}/privateSpace/`+PrivateSpace.id,PrivateSpace ,{'headers': headers});
  }

  deletePrivateSpace(idA:any){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"))
    return this.http.delete(`${environment.url}/privateSpace/`+idA ,{'headers': headers});
  }

  removeCustomerToPrivateSpace(id: number, userId: String){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.put<any>(`${environment.url}/privateSpace/remove/`+id+`?userId=${userId}`,{'headers': headers});
  }

  removeManagerForPrivateSpace(id: number, userId: String){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.put<any>(`${environment.url}/privateSpace/remove/manager/`+id+`?userId=${userId}`,{'headers': headers});
  }

  removeProuctOrServiceToPrivateSpace(id: number, variantId: string){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.post<any>(`${environment.url}/privateSpace/remove/variant/`+id+`?variantId=${variantId}`,{'headers': headers});
  }

  getPostInPrivateSpace(idA:number): Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get(`${environment.url}/privateSpace/post/`+idA+`?fields=postServiceModels,postPromotions,postSubProducts`,{'headers': headers});
  }

  getAllPostInAllPrivateSpace(): Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get(`${environment.url}/privateSpace/post/all`+`?fields=postServiceModels,postPromotions,postSubProducts`,{'headers': headers});
  }

  getAllPostByUser(page: number, size: number, minPrice: number, maxPrice: number, isFilterByProductAndService: boolean, isFilterByService: boolean, isFilterByProduct: boolean, isCheckedAnnoncePromotion: boolean, isCheckedAnnonceVedette: boolean, searchText: any): Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get(`${environment.url}/privateSpace/post/all`+`?fields=postServiceModels,postPromotions,postSubProducts&postSearchText=${searchText}&page=${page}&size=${size}&minPrice=${minPrice}&maxPrice=${maxPrice}&isFilterByProductAndService=${isFilterByProductAndService}&isFilterByService=${isFilterByService}&isFilterByProduct=${isFilterByProduct}&isCheckedAnnoncePromotion=${isCheckedAnnoncePromotion}&isCheckedAnnonceVedette=${isCheckedAnnonceVedette}`,{'headers': headers});
  }

  addProductOrServiceToSpace(id: number,product:Product[], service: Service[]){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));

    const requestBody = { product, service };

    return this.http.post<any>(`${environment.url}/privateSpace/update/variant/`+id,requestBody,{'headers': headers});
  }
}
